export default {
  setLists(state, data) {
    state.lists = data;
  },

  setCampaignsMJ(state, data) {
    state.campaignsMJ = data;
  },
};
